import React from 'react';
import { useUserStore } from '../stores';
import { isSupportChatConfigured } from '../api/zabota_chat_api';
import { SupportChatDisabled, SupportChatLoadingUser, SupportChatNotConfigured } from '../features/SupportChat/SupportChatGate';
import SupportChatWindow from '../features/SupportChat/SupportChatWindow';

const SupportChat = () => {
  const { user } = useUserStore();

  if (process.env.REACT_APP_FEATURE_SUPPORT_CHAT !== 'true') {
    return <SupportChatDisabled />;
  }

  if (!isSupportChatConfigured()) {
    return <SupportChatNotConfigured />;
  }

  if (!user?.id || !user?.fio) {
    return <SupportChatLoadingUser />;
  }

  return <SupportChatWindow cabinetUserId={user.id} fio={user.fio} />;
};

export default SupportChat;
